import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
    IceFormState,
    IceLoadState,
    SpacesIceServer,
    SpacesIceServerDefault,
    SpacesIceServerID,
} from "userful-chronos-app-common-js/dist/models/spaces/ice";
import {
    requestAddIceServer,
    requestListIceServers,
    requestRemoveIceServer,
    requestUpdateIceServer,
} from "./msgs/ice/iceMsgSender";

export type IceState = {
    iceServers: SpacesIceServer[];
    loadState: IceLoadState;
    ice: SpacesIceServer;
    copyIce: SpacesIceServer;
    formType: IceFormState;
    openForm: boolean;
};

const initialState: IceState = {
    iceServers: [],
    loadState: "RENDER",
    ice: SpacesIceServerDefault(),
    copyIce: SpacesIceServerDefault(),
    formType: "Create",
    openForm: false,
};

export const iceSlice = createSlice({
    name: "iceSlice",
    initialState,
    reducers: {
        getIceFromServer: (state, action: PayloadAction<{}>) => {
            requestListIceServers();
        },
        addIceToServer: (state, action: PayloadAction<SpacesIceServer>) => {
            requestAddIceServer(action.payload);
        },
        updateIceToServer: (state, action: PayloadAction<SpacesIceServer>) => {
            requestUpdateIceServer(action.payload);
        },
        removeIceToServer: (state, action: PayloadAction<SpacesIceServerID>) => {
            requestRemoveIceServer(action.payload);
        },

        setIceServers: (state, action: PayloadAction<SpacesIceServer[]>) => {
            state.iceServers = action.payload;
        },
        setIceServer: (state, action: PayloadAction<SpacesIceServer>) => {
            state.ice = action.payload;
        },
        setCopyIceServer: (state, action: PayloadAction<SpacesIceServer>) => {
            state.copyIce = action.payload;
        },
        addOrUpdateIceServer: (state, action: PayloadAction<SpacesIceServer>) => {
            const uniqueIds = new Set();
            // First filter out any duplicates
            state.iceServers = state.iceServers.filter((server) => {
                const serverId = server?.id?.value;
                if (!serverId || uniqueIds.has(serverId)) {
                    return false;
                }
                uniqueIds.add(serverId);
                return true;
            });

            // Then add or update the new server
            const foundIndex = state.iceServers.findIndex((item) => item.id.value === action.payload.id.value);
            if (foundIndex < 0) {
                state.iceServers = [...state.iceServers, { ...action.payload }];
            } else {
                state.iceServers = [
                    ...state.iceServers.slice(0, foundIndex),
                    { ...action.payload },
                    ...state.iceServers.slice(foundIndex + 1),
                ];
            }
        },
        removeIceServer: (state, action: PayloadAction<SpacesIceServerID>) => {
            state.iceServers = state.iceServers.filter((ice) => ice.id.value !== action.payload.value);
        },
        changeLoadState: (state, action: PayloadAction<IceLoadState>) => {
            state.loadState = action.payload;
        },
        setFormType: (state, action: PayloadAction<IceFormState>) => {
            state.formType = action.payload;
        },
        setOpenForm: (state, action: PayloadAction<boolean>) => {
            state.openForm = action.payload;
        },
    },
});

export const iceActions = iceSlice.actions;

export default iceSlice.reducer;
